//ENV VARS
let vivus;
const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const days = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'];

jQuery(document).ready(function($){
    // HEADER
    // fixed header
    let win = jQuery(window);
    let winW = win.width();
    win.on('scroll', function() {
        if (jQuery(this).scrollTop() > 100) {
            jQuery('.top-bar').addClass('active');
        } else {
            jQuery('.top-bar').removeClass('active');
        }
    });
    // show menu
    jQuery('.menu-trigger').on('click', function(e) {
        e.preventDefault();
        jQuery('#menu-overlay').slideToggle();
    });
    // BLOCKS
    // hero slider block
    if (jQuery('.hero-slider-block').length) {
        var slider = tns({
            container: '#hero-slider',
            mode: 'gallery',
            items: 1,
            controls: false,
            nav: false,
            slideBy: 1,
            autoplay: true,
            loop: true,
            autoplayButtonOutput: false
        });
        jQuery('.hero-slider-block .icons li').on('mouseover', function() {
            let id = jQuery(this).attr('data-content');
            jQuery('#icon-text-spacer').hide();
            jQuery('.icon-subtitle').hide();
            jQuery('#' + id).show();
        });
        jQuery('.hero-slider-block .icons li').on('mouseout', function() {
            jQuery('#icon-text-spacer').show();
            jQuery('.icon-subtitle').hide();
        });
    }
    // services block
    if (jQuery('.services-block').length && winW < 1024) {
        var slider = tns({
            container: '.services-container',
            items: 1,
            controls: false,
            slideBy: 1,
            autoplay: true,
            center: true,
            loop: true,
            nav: true,
            navPosition: 'bottom',
            autoplayButtonOutput: false,
            responsive: {
                '1024': {
                    disable: true
                }
            }
        });
    }
    // testimonial block
    if (jQuery('.testimonial-block').length) {
        var slider = tns({
            container: '#testimonial-slider',
            items: 1,
            gutter: 30,
            controls: false,
            slideBy: 1,
            autoplay: true,
            center: true,
            loop: true,
            nav: true,
            navPosition: 'bottom',
            autoplayButtonOutput: false,
            responsive: {
                '1024': {
                    items: 3
                }
            }
        });
    }
    // tabs block
    if(jQuery('.tabs-block').length) {
        jQuery('.tabs-select').on('change', function(e) {
            let id = jQuery('option:selected', this).attr('data-tab');
            jQuery(this).closest('.tabs-block').find('.tab-content').hide();
            jQuery(this).closest('.tabs-block').find('.tab-content[data-content="' + id + '"]').show();
        });
        jQuery('.tabs-container .button').on('click', function(e) {
            let id = jQuery(this).attr('data-tab');
            e.preventDefault();
            jQuery(this).toggleClass('active');
            jQuery(this).closest('.tabs-block').find('.tab-content').hide();
            jQuery(this).closest('.tabs-block').find('.tab-content[data-content="' + id + '"]').show();
        });
        jQuery('.accordion-container .title').on('click', function() {
            jQuery(this).toggleClass('active');
            jQuery(this).parent().find('.content').slideToggle();
        });
    }
    // text image button block
    if (jQuery('.tib-block').length) {
        jQuery('.tib-block a').on('click', function(e) {
            e.preventDefault();
            jQuery(this).parent().find('.extra').slideToggle();
        });
    }
    // curve text button block
    if (jQuery('.ctb-block').length) {
        jQuery('.gradient-bg').addClass('ctb');
        jQuery('footer').addClass('ctb');
    }
    // referral form block
    if (jQuery('.referral-form-block').length) {
        registerModalControls();
    }
    // RESPONSIVE
    // icon highlight block
    if (jQuery('.icon-highlight-block').length) {
        var slider = tns({
            container: '.icon-highlight-block .icons-container',
            items: 1,
            controls: false,
            slideBy: 1,
            autoplay: true,
            center: true,
            loop: true,
            nav: true,
            navPosition: 'bottom',
            autoplayButtonOutput: false,
            responsive: {
                '1024': {
                    disable: true
                }
            }
        });
    }
    // LOGIN MODAL
    jQuery('.mybigodes-enter').on('click', function(e) {
        e.preventDefault();
        jQuery('#login-modal').foundation('open');
    });
    // PASSWORD RECOVERY MODAL
    jQuery('#password-reset').on('click', function(e) {
        e.preventDefault();
        jQuery('#recover-password-modal').foundation('open');
    });
    // REGISTER MODAL
    jQuery('#register-modal-open').on('click', function(e){
        e.preventDefault();
        resetRegisterForm();
        registerModalControls();
    });
    // LOGIN
    jQuery('#customer-login').on('submit', function(e){
        loadingStatus();
        e.preventDefault();
        // jQuery(this).parsley().validate();
        
        // if (jQuery(this).parsley().isValid()) {
            let form_data = jQuery(this).serializeArray();
            let form_status = jQuery(this).find('.form-message');
            $.ajax({
                type: data.rest.endpoints.customer_login.method,
                dataType: 'json',
                url: data.rest.endpoints.customer_login.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                if (results.loggedin == true){
                    document.location.href = data.rest.endpoints.customer_login.redirect;
                } else {
                    loadingStatus();
                    form_status.addClass('error');
                    form_status.html(results.message);
                }
            }).fail(function(xhr){
                console.log(xhr);
            });
        // }
    });
    // PASSWORD RECOVERY
    jQuery('#password-recover').on('submit', function(e){
        loadingStatus();
        e.preventDefault();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            let form_data = jQuery(this).serializeArray();
            let form_status = jQuery(this).find('.form-message');
            $.ajax({
                type: data.rest.endpoints.password_recovery.method,
                dataType: 'json',
                url: data.rest.endpoints.password_recovery.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                loadingStatus();
                if (results.user == true){
                    successModal(data.rest.messages.recovered);
                } else {
                    form_status.html(data.rest.messages.nouser);
                }
            }).fail(function(xhr){
                console.log(xhr);
            });
        // }
    });
    // DATE FIELDS
    if (jQuery('#register-date').length) {
        var picker = new Litepicker({
            element: document.getElementById('register-date'),
            format: 'DD/MM/YYYY',
            lang: 'pt-PT',
            dropdowns: {
                minYear: 1900,
                maxYear: null,
                months: true,
                years: true,
            },
            showWeekNumbers: false
        });
    }
    if (jQuery('#customer-birthdate').length) {
        var picker = new Litepicker({
            element: document.getElementById('customer-birthdate'),
            format: 'DD/MM/YYYY',
            lang: 'pt-PT',
            dropdowns: {
                minYear: 1900,
                maxYear: null,
                months: true,
                years: true,
            },
            showWeekNumbers: false
        });
    }
    if (jQuery('#animal-birthdate').length) {
        var picker = new Litepicker({
            element: document.getElementById('animal-birthdate'),
            format: 'DD/MM/YYYY',
            lang: 'pt-PT',
            dropdowns: {
                minYear: 1900,
                maxYear: null,
                months: true,
                years: true,
            },
            showWeekNumbers: false
        });
    }
    // TESTIMONIAL MESSAGE
    jQuery('#testimonial-message').on('submit', function(e) {
        e.preventDefault();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            let form_data = jQuery(this).serializeArray();
            $.ajax({
                type: data.rest.endpoints.testimonial_message.method,
                dataType: 'json',
                url: data.rest.endpoints.testimonial_message.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                jQuery('#testimonial-message').hide();
                jQuery('#testimonial-modal .success-message').show();
            }).fail(function(xhr){
                console.log(xhr);
            });
        // }
    });
    // REGISTER & MYBIGODES PROFILE - check user by mail
    jQuery('input.customer-email').on('blur', function(e){
        let form_container = jQuery(this).closest('form');
        let form_status = jQuery('.user-exists-error');
        let form_data = {
            'user' : jQuery(this).val(),
            'id' : jQuery('#user-id').val()
        };
        $.ajax({
            type: data.rest.endpoints.check_user.method,
            dataType: 'json',
            url: data.rest.endpoints.check_user.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            if (results.message == 'user_exists'){
                form_status.html(data.rest.messages.exists);
                form_container.find('input[type="submit"]').prop('disabled', true);
            } else {
                form_status.html('');
                form_container.find('input[type="submit"]').prop('disabled', false);
            }
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    jQuery('input[name="register-email]"').on('focus', function(e){
        jQuery('.user-exists-error').empty();
    });
    // MYBIGODES PROFILE & MYBIGODES APPOINTMENT - district, county selection
    jQuery('#appointment-district').on('change', function(e){
        let district = jQuery(this).val();
        let counties = JSON.parse(jQuery('.register-county').attr('data-counties'));

        jQuery('#mybigodes-new-appointment').attr('data-district', district);
        jQuery('.register-county').empty();
        $.each(counties, function(key, value){
            if (key.includes(district)) {
                let county_entry = '<option value="' + key + '">' + value + '</option>';
                jQuery('.register-county').append(county_entry);
            }
        });
        if (jQuery('.register-county option').length) {
            jQuery('.register-county-container').fadeIn();
        } else {
            jQuery('.register-county-container').fadeOut();
        }
        jQuery('.register-county').trigger('change');
    });
    // REGISTER - submit register
    jQuery('.customer-register').on('submit', function(e){
        e.preventDefault();
        // jQuery(this).parsley().validate();
        
        // if (jQuery(this).parsley().isValid()){
        let form_data = jQuery(this).serializeArray();
        
        let form_status = jQuery(this).find('.form-message');
        $.ajax({
            type: data.rest.endpoints.customer_register.method,
            dataType: 'json',
            url: data.rest.endpoints.customer_register.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            if (results.message == 'success'){
                jQuery('#login-modal .modal-title').html(data.rest.messages.register_success);
                jQuery('#login-modal').foundation('open');
            } else {
                form_status.addClass('error');
                form_status.html(data.rest.messages.error);
            }
        }).fail(function(xhr){
            console.log(xhr);
        });
        // }
    });
    // MYBIGODES
    // On load, check if appointment param is present
    if (jQuery('.content.mybigodes').length) {
        let param = getUrlParameter('appointment');
        switch(param) {
            case 'yes':
                jQuery('#mybigodes-schedule-label').trigger('click');
                break;
            case 'new':
                jQuery('#mybigodes-schedule-label').trigger('click');
                jQuery('#schedule3-label').trigger('click');
                break;
        }
    }
    // MYBIGODES PROFILE - update profile
    jQuery('#customer-edit').on('submit', function(e){
        e.preventDefault();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            loadingStatus();
            let form_data = jQuery(this).serializeArray();
            $.ajax({
                type: data.rest.endpoints.customer_update.method,
                dataType: 'json',
                url: data.rest.endpoints.customer_update.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                loadingStatus();
                successModal(data.rest.messages.edit_success);
                updateAppointmentAddress();
            }).fail(function(xhr){
                console.log(xhr);
            });
        // }
    });
    // MYBIGODES PROFILE - password change
    jQuery('.password-check').on('blur', function(){
        jQuery('#password-change').parsley();
    });
    jQuery('#password-change').on('submit', function(e){
        e.preventDefault();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            loadingStatus();
            let form_data = jQuery('#password-change').serializeArray();
            $.ajax({
                type: data.rest.endpoints.password_update.method,
                dataType: 'json',
                url: data.rest.endpoints.password_update.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                loadingStatus();
                successModal(data.rest.messages.edit_password_success, true);
            }).fail(function(xhr){
                loadingStatus();
                console.log(xhr);
            });
        // }
    });
    // MYBIGODES SCHEDULE - schedule entries
    jQuery('#mybigodes-tabs').on('change.zf.tabs', function() {
        if (jQuery('#mybigodes-schedule:visible').length) {
            jQuery('#schedule1 .schedule-entry').each(function(i, el) {
                let parent_height = jQuery(el).height();
                jQuery(el).find('button').height(parent_height);
            });
        }
    });
    // MYBIGODES SCHEDULE - edit appointment
    jQuery(document).on('click', '.appointment-edit', function(e) {
        let appointment = jQuery(this).parents('.schedule-entry').attr('data-appointment');
        let vet = jQuery(this).parents('.schedule-entry').attr('data-vet');
        let type = jQuery(this).parents('.schedule-entry').attr('data-type');
        let animal_photo = jQuery(this).parents('.schedule-entry').attr('data-photo');
        let animal_name = jQuery(this).parents('.schedule-entry').attr('data-name');
        let service = jQuery(this).parents('.schedule-entry').attr('data-service');
        let service_icon = jQuery(this).parents('.schedule-entry').attr('data-service-icon');
        let vet_photo = jQuery(this).parents('.schedule-entry').attr('data-vet-photo');
        let vet_name = jQuery(this).parents('.schedule-entry').attr('data-vet-name');
        jQuery('#appointment-edit-modal .calendar-container').empty();
        jQuery('#appointment-edit-modal #appointment-calendar-date').empty();
        jQuery('#appointment-edit-modal .calendar-container').append(jQuery('#mybigodes-new-appointment'));
        jQuery('#mybigodes-new-appointment').attr('data-vet', vet);
        jQuery('#mybigodes-new-appointment #appointment-type').val(type);
        jQuery('#mybigodes-new-appointment').attr('data-update', '1');
        jQuery('#mybigodes-new-appointment .photo-button .photo-button-image[data-vet="0"]').addClass('active');
        jQuery('#edit-appointment-confirm-modal .animal-photo').css('background-image', 'url(' + animal_photo + ')');
        jQuery('#edit-appointment-confirm-modal .animal-name').html(animal_name);
        jQuery('#edit-appointment-confirm-modal .icon-button-image').css('background-image', 'url(' + service_icon + ')');
        jQuery('#edit-appointment-confirm-modal .icon-button-caption').html(service);
        jQuery('#edit-appointment-confirm-modal .photo-button-image').css('background-image', 'url(' + vet_photo + ')');
        jQuery('#edit-appointment-confirm-modal .photo-button-caption').html(vet_name);
        jQuery('#mybigodes-new-appointment .mybigodes-form-step').hide();
        jQuery('#mybigodes-new-appointment #na-step-6').show();
        jQuery('#mybigodes-new-appointment #na-step-6 .prev-step').hide();
        jQuery('#mybigodes-new-appointment #na-step-6 .calendar-vet').empty();
        jQuery('#mybigodes-new-appointment #na-step-6 #appointment-calendar-hours ul').empty();
        jQuery('#mybigodes-new-appointment #calendar-vets .photo-button:not([data-service="' + type + '"])').hide();
        jQuery('#mybigodes-new-appointment .photo-button-image').removeClass('active');
        jQuery('#mybigodes-new-appointment .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
        jQuery('#mybigodes-new-appointment .calendar-vet').html(jQuery('#mybigodes-new-appointment #na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
        jQuery('#edit-appointment-confirm-modal #appointment-edit-confirm').attr('data-appointment', appointment);
        jQuery('#appointment-edit-modal').foundation('open');
        startCalendar();
    });
    jQuery('#appointment-edit-confirm').on('click', function(e) {
        let appointment = jQuery(this).attr('data-appointment');
        let date = jQuery('#appointment-date').val();
        let form_data = {
            appointment: appointment,
            date: date
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.edit_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.edit_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            successModal(data.rest.messages.edit_appointment, true);
            reloadWellbeingAppointments();
            reloadAppointments();
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    jQuery('#appointment-edit-modal').on('closed.zf.reveal', function(e) {
        jQuery('.cld-main').remove();
        jQuery('#mybigodes-new-appointment #na-step-6').hide();
        jQuery('#mybigodes-new-appointment #na-step-1').show();
        jQuery('#mybigodes-new-appointment').attr('data-vet', '');
        jQuery('#mybigodes-new-appointment').attr('data-update', 0);
        jQuery('#mybigodes-new-appointment .calendar-vet').html('');
        jQuery('#mybigodes-new-appointment .photo-button .photo-button-image').removeClass('active');
        jQuery('#schedule3').append(jQuery('#mybigodes-new-appointment'));
        jQuery('#mybigodes-new-appointment #calendar-vets .photo-button').show();
    });
    // MYBIGODES SCHEDULE - cancel appointment
    jQuery(document).on('click', '#schedule1 .appointment-cancel', function(e) {
        let appointment = jQuery(this).attr('data-appointment');
        let form_data = {
            appointment: appointment
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.get_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.get_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            jQuery('#appointment-cancel-modal .appointment-date').html(results.date.replace(/-/g, '/'));
            jQuery('#appointment-cancel-modal .animal-photo').css('background-image', 'url(' + results.animal_photo + ')');
            jQuery('#appointment-cancel-modal .animal-name').html(results.animal_name);
            jQuery('#appointment-cancel-modal .icon-button-image').css('background-image', 'url(' + results.service_icon + ')');
            jQuery('#appointment-cancel-modal .icon-button-caption').html(results.service_name);
            jQuery('#appointment-cancel-modal .photo-button-image').css('background-image', 'url(' + results.vet_photo + ')');
            jQuery('#appointment-cancel-modal .photo-button-caption').html(results.vet_name);
            jQuery('#appointment-cancel').attr('data-appointment', appointment);
            jQuery('#appointment-cancel-modal').foundation('open');
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    jQuery('#appointment-mantain').on('click', function(e) {
        jQuery('#appointment-cancel-modal').foundation('close');
    });
    jQuery('#appointment-cancel').on('click', function(e) {
        let appointment = jQuery(this).attr('data-appointment');
        let form_data = {
            appointment: appointment,
            referrer: 'schedule'
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.cancel_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.cancel_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            successModal(data.rest.messages.cancel_appointment, true);
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    // MYBIGODES SCHEDULE - schedule wellbeing item
    jQuery(document).on('click', '.wellbeing-schedule', function(e) {
        let appointment = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-appointment');
        let type = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-type');
        let type_label = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-type-label');
        let motive = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-motive');
        let motive_label = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-motive-label');
        let context = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-context');
        let animal = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-animal');
        let animal_name = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-animal-name');
        let day = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-day');
        let month = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-month');
        let year = jQuery(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-year');
        let animal_icon = jQuery('#mybigodes-new-appointment .animal-icon[data-animal="' + animal + '"]');
        let service_icon = jQuery('#mybigodes-new-appointment .icon-button[data-type="' + type + '"]');
        const district = jQuery('#mybigodes-new-appointment').attr('data-district');
        jQuery('#wellbeing-create-modal .process-container').append(jQuery('#mybigodes-new-appointment'));
        jQuery('#mybigodes-new-appointment #appointment-id').val(appointment);
        jQuery('#mybigodes-new-appointment #appointment-type').val(type);
        jQuery('#mybigodes-new-appointment #appointment-motive').val(motive);
        jQuery('#mybigodes-new-appointment #appointment-context').val(context);
        jQuery('#mybigodes-new-appointment #appointment-animals').val(animal);
        jQuery('#mybigodes-new-appointment').attr('data-day', day);
        jQuery('#mybigodes-new-appointment').attr('data-month', month);
        jQuery('#mybigodes-new-appointment').attr('data-year', year);
        jQuery('#mybigodes-new-appointment').attr('data-wellbeing', 1);
        jQuery('#wellbeing-create-modal .appointment-date').html(animal_name + ' - ' + type_label + ' - ' + motive_label);
        jQuery('#mybigodes-new-appointment .mybigodes-form-step').hide();
        jQuery('#mybigodes-new-appointment #na-step-5').show();
        jQuery('#mybigodes-new-appointment #na-step-5 .prev-step').hide();
        jQuery('#mybigodes-new-appointment #na-step-5 .photo-button').show();
        jQuery('#mybigodes-new-appointment #na-step-5 .photo-button:not([data-service="' + type + '"])').hide();
        jQuery('#mybigodes-new-appointment #na-step-6 .calendar-vet').empty();
        jQuery('#mybigodes-new-appointment #na-step-6 #appointment-calendar-hours ul').empty();
        jQuery('#mybigodes-new-appointment #calendar-vets .photo-button:not([data-service="' + type + '"])').hide();
        jQuery('#mybigodes-new-appointment .photo-button-image').removeClass('active');
        jQuery('#new-appointment-confirm-modal .animal').append(jQuery(animal_icon).clone());
        jQuery('#new-appointment-confirm-modal .service').append(jQuery(service_icon).clone());
        jQuery('#na-step-5 .photo-button').each(function(index, item) {
            let vet_district = jQuery(item).attr('data-districts');
            if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
                jQuery(this).hide();
            }
        });
        jQuery('#wellbeing-create-modal').foundation('open');
    });
    jQuery('#wellbeing-create-modal').on('closed.zf.reveal', function(e) {
        jQuery('#wellbeing-create-modal .appointment-date').html('');
        jQuery('.cld-main').remove();
        jQuery('#mybigodes-new-appointment .mybigodes-form-step').hide();
        jQuery('#mybigodes-new-appointment #na-step-1').show();
        jQuery('#mybigodes-new-appointment').attr('data-vet', '');
        jQuery('#mybigodes-new-appointment').attr('data-wellbeing', 0);
        jQuery('#mybigodes-new-appointment #na-step-5 .next-step').hide();
        jQuery('#mybigodes-new-appointment .calendar-vet').html('');
        jQuery('#mybigodes-new-appointment .photo-button .photo-button-image').removeClass('active');
        jQuery('#schedule3').append(jQuery('#mybigodes-new-appointment'));
        jQuery('#mybigodes-new-appointment #calendar-vets .photo-button').show();
    });
    jQuery('#new-appointment-confirm-modal').on('closed.zf.reveal', function(e) {
        jQuery('#new-appointment-confirm-modal .animal').empty();
        jQuery('#new-appointment-confirm-modal .service').empty();
        jQuery('#new-appointment-confirm-modal .vet').empty();
    });
    // MYBIGODES SCHEDULE & ANIMALS - cancel wellbeing item
    jQuery(document).on('click', '.wellbeing-maintain', function(e) {
        jQuery('#wellbeing-cancel-modal').foundation('close');
    });
    jQuery(document).on('click', '.wellbeing-delete', function(e) {
        let appointment = jQuery(this).attr('data-appointment');
        let date = jQuery(this).closest('.schedule-entry').find('.date').text();
        let form_data = {
            appointment: appointment
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.get_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.get_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            jQuery('#wellbeing-cancel-modal .appointment-date').html(date);
            jQuery('#wellbeing-cancel-modal .animal-photo').css('background-image', 'url(' + results.animal_photo + ')');
            jQuery('#wellbeing-cancel-modal .animal-name').html(results.animal_name);
            jQuery('#wellbeing-cancel-modal .icon-button-image').css('background-image', 'url(' + results.service_icon + ')');
            jQuery('#wellbeing-cancel-modal .icon-button-caption').html(results.service_name);
            jQuery('#wellbeing-cancel-modal .photo-button-image').css('background-image', 'url(' + results.vet_photo + ')');
            jQuery('#wellbeing-cancel-modal .photo-button-caption').html(data.rest.messages.no_vet);
            jQuery('#wellbeing-cancel').attr('data-appointment', appointment);
            jQuery('#wellbeing-cancel-modal').foundation('open');
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    jQuery('#wellbeing-cancel').on('click', function(e) {
        let appointment = jQuery(this).attr('data-appointment');
        let customer = jQuery(this).attr('data-customer');
        let form_data = {
            appointment: appointment,
            referrer: 'wellbeing'
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.cancel_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.cancel_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            successModal(data.rest.messages.delete_wellbeing, true);
            reloadWellbeingAppointments();
            reloadAppointments();
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    // MYBIGODES POINTS - show benefits
    jQuery('.show-rewards').on('click', function(e) {
        e.preventDefault();
        jQuery('.form-message').hide();
        jQuery('.points-screen').hide();
        jQuery('#points-rewards').show();
    });
    jQuery('.show-actions').on('click', function(e) {
        e.preventDefault();
        jQuery('.form-message').hide();
        jQuery('.points-screen').hide();
        jQuery('#points-actions').show();
    });
    // MYBIGODES POINTS - show history
    jQuery('.show-points').on('click', function() {
        reloadHistory(jQuery('.points-history').attr('data-customer'));
    });
    // MYBIGODES POINTS - redeem codes
    jQuery('#points-redeem').on('submit', function(e){
        e.preventDefault();
        loadingStatus();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            let form_data = jQuery(this).serializeArray();
            $.ajax({
                type: data.rest.endpoints.code_redeem.method,
                dataType: 'json',
                url: data.rest.endpoints.code_redeem.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                loadingStatus();
                if (results.message == 'success') {
                    successModal(data.rest.messages.code_success);
                    jQuery('.no-points').hide();
                    jQuery('#customer-points').html(results.points);
                } else {
                    successModal(data.rest.messages.code_error);
                }
                reloadHistory(jQuery('.points-history').attr('data-customer'));
            }).fail(function(xhr){
                successModal(data.rest.messages.code_error);
            });
        // }
    });
    // MYBIGODES POINTS - referral
    jQuery('input[name="referral-name"]').on('input', function(){
        let name = jQuery(this).val();
        let message = jQuery('textarea[name="referral-message"]').val();
        let friend = message.split(',', 1)[0];
        jQuery('textarea[name="referral-message"]').val(jQuery('textarea[name="referral-message"]').val().replace(friend, 'Olá ' + name));
    });
    jQuery('#referral-send').on('submit', function(e){
        e.preventDefault();
        jQuery('textarea[name="referral-message"]').attr('disabled', false);
        let email = jQuery(this).find('input[name="referral-email"]');
        let phone = jQuery(this).find('input[name="referral-phone"]');
        if (!email.val() && !phone.val()) {
            jQuery('textarea[name="referral-message"]').attr('disabled', true);
            successModal(data.rest.messages.referral_contact);
        } else {
            // jQuery(this).parsley().validate();
            // if (jQuery(this).parsley().isValid()){
                loadingStatus();
                let form_data = jQuery(this).serializeArray();
                jQuery('textarea[name="referral-message"]').attr('disabled', true);
                $.ajax({
                    type: data.rest.endpoints.customer_referral.method,
                    dataType: 'json',
                    url: data.rest.endpoints.customer_referral.url,
                    data: form_data,
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                    }
                }).done(function(results){
                    loadingStatus();
                    if (results.message == 'success') {
                        successModal(data.rest.messages.referral_success);
                    } else {
                        successModal(data.rest.messages.error);
                    }
                }).fail(function(xhr){
                    loadingStatus();
                    successModal(data.rest.messages.error);
                });
            // }
        }
    });
    // MYBIGODES - SCHEDULE
    // new package appointment
    jQuery('.package-schedule').on('click', function(e) {
        let appointment = jQuery(this).closest('.schedule-entry').attr('data-appointment');
        let type_label = jQuery(this).closest('.schedule-entry').attr('data-type-label');
        let type = jQuery(this).closest('.schedule-entry').attr('data-type');
        let context = jQuery(this).closest('.schedule-entry').attr('data-context');
        jQuery('#mybigodes-new-appointment #appointment-id').val(appointment);
        jQuery('#mybigodes-new-appointment #appointment-type').val(type);
        jQuery('#mybigodes-new-appointment #appointment-context').val(context);
        jQuery('#mybigodes-new-appointment').attr('appointment-package', 1);
        jQuery('#mybigodes-new-appointment .package-title').append(type_label);
        jQuery('#mybigodes-new-appointment .package-title').show();
        jQuery('#na-step-5 .photo-button').each(function(index, item) {
            let vet_district = jQuery(item).attr('data-districts');
            if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
                jQuery(this).hide();
            }
        });
        jQuery('a[href="#schedule3"').trigger('click');
    });
    // new appointment form
    jQuery('#schedule3-label').on('click', function(e) {
        appointmentReset();
        contextMessage(data.rest.messages.na_where_title, data.rest.messages.na_where_text);
    });
    jQuery(document).on('click', '#mybigodes-new-appointment .button-row input[type="button"]', function(e){
        let title, text, step;
        jQuery(this).closest('.mybigodes-form-step').slideUp();
        if (jQuery(this).hasClass('next-step')) {
            jQuery(this).closest('.mybigodes-form-step').next().slideDown();
            step = jQuery(this).closest('.mybigodes-form-step').next().attr('id');
        } else {
            jQuery(this).closest('.mybigodes-form-step').prev().slideDown();
            step = jQuery(this).closest('.mybigodes-form-step').prev().attr('id');
        }
        switch (step) {
            case 'na-step-1':
                title = data.rest.messages.na_where_title;
                text = data.rest.messages.na_where_text;
                break;
            case 'na-step-2':
                title = data.rest.messages.na_who_title;
                text = data.rest.messages.na_who_text;
                break;
            case 'na-step-3':
                title = data.rest.messages.na_what_title;
                text = data.rest.messages.na_what_text;
                break;
            case 'na-step-4':
                title = data.rest.messages.na_what_title;
                text = data.rest.messages.na_what_specify_text;
                break;
            case 'na-step-5':
                title = data.rest.messages.na_dr_title;
                text = data.rest.messages.na_dr_text;
                break;
            case 'na-step-6':
                title = data.rest.messages.na_when_title;
                text = data.rest.messages.na_when_text;
                break;
        }
        contextMessage(title, text);
    });
    jQuery(document).on('click', '#na-step-2 .animal-icon', function(e) {
        jQuery(this).find('.animal-photo').toggleClass('active');
        jQuery(this).find('.animal-photo');
        if (jQuery('#na-step-2 .animal-photo.active').length) {
            jQuery('#na-step-2 .next-step').show();
            if (jQuery('#mybigodes-new-appointment').attr('appointment-package') == 1) {
                jQuery('#na-step-2 .next-step').trigger('click');
            }
        } else {
            jQuery('#na-step-2 .next-step').hide();
        }
        if (jQuery('#na-step-2 .animal-photo.active').length > 2) {
            jQuery('#na-step-2 .animals-warning').fadeIn();
        } else {
            jQuery('#na-step-2 .animals-warning').fadeOut();
        }
    });
    // set appointment animals
    jQuery(document).on('click', '#na-step-2 .next-step', function(e) {
        let animals = [];
        jQuery('#new-appointment-confirm-modal .appointment-data .animal').empty();
        jQuery('#na-step-2 .animal-photo.active').each(function(i, el) {
            let animal_id = jQuery(this).parent().attr('data-animal');
            animals.push(animal_id);
            let icon = jQuery(this).parent();
            jQuery('#new-appointment-confirm-modal .appointment-data .animal').append(jQuery(icon).clone());
        });
        jQuery('#appointment-animals').val(animals);
        if (jQuery('#mybigodes-new-appointment').attr('appointment-package') == 1) {
            jQuery('#na-step-3 .icon-button[data-type="' + jQuery('#appointment-type').val() + '"]').trigger('click');
        }
    });
    jQuery(document).on('click', '#na-step-3 .icon-button', function(e) {
        jQuery('#appointment-type').val(jQuery(this).attr('data-type'));
        jQuery('#na-step-5 .photo-button').hide();
        jQuery('#na-step-6 .photo-button').hide();
        jQuery('#na-step-5 .photo-button[data-service="' + jQuery(this).attr('data-type') + '"]').show();
        jQuery('#na-step-6 .photo-button[data-service="' + jQuery(this).attr('data-type') + '"]').show();
        jQuery('#na-step-4 .type-icon').empty();
        jQuery('#na-step-3 .icon-button-image').removeClass('active');
        jQuery(this).clone().appendTo('#na-step-4 .type-icon');
        jQuery(this).find('.icon-button-image').addClass('active');
        if (jQuery('.icon-button-image.active').length) {
            jQuery('#na-step-4 .motive-list').hide();
            jQuery('#na-step-4 #' + jQuery(this).attr('data-type') + '-motive').show();
            jQuery('#na-step-3 .next-step').show();
        } else {
            jQuery('#na-step-3 .next-step').hide();
        }
        if (jQuery('#mybigodes-new-appointment').attr('appointment-package') == 1) {
            jQuery('#na-step-3 .next-step').trigger('click');
        }
    });
    jQuery(document).on('click', '#na-step-3 .next-step', function(e) {
        jQuery('#new-appointment-confirm-modal .appointment-data .service').empty();
        jQuery('#new-appointment-confirm-modal .appointment-data .animal-icon').each(function(i, el) {
            jQuery('#na-step-3 .icon-button-image.active').parent().clone().appendTo('#new-appointment-confirm-modal .appointment-data .service');
        });
        if (jQuery('#mybigodes-new-appointment').attr('appointment-package') == 1) {
            jQuery('#na-step-4 .prev-step').hide();
        }
    });
    jQuery('#na-step-4 .motive-list button').on('click', function(e) {
        e.preventDefault();
        jQuery('#na-step-4 .motive-list .list').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('#appointment-motive').val(jQuery(this).attr('data-customer-motive'));
        jQuery('.appointment-description-container').fadeIn();
        jQuery('#na-step-4 .next-step').show();
    });
    jQuery(document).on('click', '#na-step-4 .prev-step', function(e) {
        jQuery('.appointment-description-container').fadeOut();
    });
    jQuery(document).on('click', '#na-step-4 .next-step', function(e) {
        const district = jQuery('#mybigodes-new-appointment').attr('data-district');
        jQuery('#na-step-5 .photo-button').each(function() {
            let vet_district = jQuery(this).attr('data-districts');
            if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
                jQuery(this).hide();
            }
        });
    });
    jQuery('#na-step-5 .photo-button').on('click', function(e) {
        let vet = jQuery(this).attr('data-vet');
        jQuery('#na-step-5 .photo-button-image').removeClass('active');
        jQuery(this).find('.photo-button-image').addClass('active');
        jQuery('#na-step-6 .photo-button .photo-button-image').removeClass('active');
        jQuery('#na-step-6 .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
        jQuery('#na-step-6 .calendar-vet').html(jQuery('#na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
        jQuery('#mybigodes-new-appointment').attr('data-vet', vet);
        jQuery('#na-step-5 .next-step').show();
    });
    jQuery('#na-step-5 .next-step').on('click', function(e) {
        let date = jQuery('#mybigodes-new-appointment').attr('data-my');
        let vet = jQuery('#mybigodes-new-appointment').attr('data-vet');
        const district = jQuery('#mybigodes-new-appointment').attr('data-district');
        jQuery('#na-step-6 .photo-button').each(function() {
            let vet_district = jQuery(this).attr('data-districts');
            if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
                jQuery(this).hide();
            }
        });
        updateVet();
        startCalendar();
    });
    jQuery('#na-step-6 .prev-step').on('click', function(e) {
        jQuery('#appointment-calendar-date').empty();
    });
    jQuery('#na-step-6 .photo-button').on('click', function(e) {
        let vet = jQuery(this).attr('data-vet');
        let date = jQuery('#mybigodes-new-appointment').attr('data-my');
        jQuery('.photo-button .photo-button-image').removeClass('active');
        jQuery(this).find('.photo-button-image').addClass('active');
        jQuery('#na-step-5 .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
        jQuery('#mybigodes-new-appointment').attr('data-vet', vet);
        jQuery('#na-step-6 .calendar-vet').html(jQuery('#na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
        updateVet();
        updateCalendar();
    });
    jQuery(document).on('click', '.cld-nav', function(e) {
        let vet = jQuery(this).attr('data-vet');
        let date = jQuery('#mybigodes-new-appointment').attr('data-my');
        updateCalendar();
    });
    jQuery(document).on('click', '#na-step-6 .cld-day.active', function(e) {
        let template = jQuery('#appointment-hour-slots').html();
        let slots = JSON.parse(jQuery(this).attr('data-schedule'));
        let day = jQuery(this).text();
        let monthyear = jQuery('.cld-datetime .today').text();
        let date = jQuery('#appointment-calendar-info').attr('data-date');
        if (day < 10) { day = '0' + day; }
        jQuery('#na-step-6 .cld-day.active .cld-number').removeClass('selected');
        jQuery(this).find('.cld-number').addClass('selected');
        jQuery('#na-step-6 .calendar-date').html(day + '-' + monthyear.replace(' ', '-'));
        jQuery('#appointment-calendar-hours ul').empty();
        jQuery('#appointment-calendar-hours').attr('data-date', day + '-' + date);
        $.each(slots.hours, function(slot){
            let start_hour = slot + ':00';
            let end = parseInt(slot.substring(0, 2)) + 1;
            if (jQuery('#appointment-type').val() == 'grooming') {
                end = parseInt(slot.substring(0, 2)) + 2;
            }
            let end_hour = end + ':00';
            let item = jQuery(template).clone();
            item.attr('data-hour', start_hour);
            item.html(start_hour + ' - ' + end_hour);
            if (jQuery('#appointment-type').val() != 'grooming') {
                jQuery('#appointment-calendar-hours ul').append(item);
            } else {
                if (slot % 2 === 0) {
                    jQuery('#appointment-calendar-hours ul').append(item);
                }
            }
        });
    });
    jQuery(document).on('click', '#appointment-calendar-hours li', function(e) {
        let fulldate = jQuery('#appointment-calendar-info .calendar-date').text().replace('-', ' de ');
        let date = jQuery('#appointment-calendar-hours').attr('data-date');
        let weekday = new Date(jQuery('#appointment-calendar-hours').attr('data-date'));
        let slot = jQuery(this).text().replace('-', ' às ');
        jQuery('#appointment-calendar-hours li').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('#appointment-date').val(date + ' ' + jQuery(this).attr('data-hour'));
        if (jQuery('#mybigodes-new-appointment').attr('data-update') == 1) {
            jQuery('#edit-appointment-confirm-modal .appointment-date').text(date + ' ' + jQuery(this).attr('data-hour'));
            jQuery('#edit-appointment-confirm-modal').foundation('open');
        } else {
            jQuery('#new-appointment-confirm-modal .appointment-date').text(date + ' ' + jQuery(this).attr('data-hour'));
            jQuery('#new-appointment-confirm-modal').foundation('open');
        }
    });
    jQuery(document).on('click', '#new-appointment-confirm-modal #new-appointment-change', function(e) {
        jQuery('#mybigodes-new-appointment .cld-number').removeClass('selected');
        jQuery('#mybigodes-new-appointment .calendar-date').empty();
        jQuery('#mybigodes-new-appointment #appointment-calendar-hours li').remove();
        jQuery('#new-appointment-confirm-modal').foundation('close');
    });
    jQuery(document).on('click', '#new-appointment-confirm-modal #new-appointment-confirm', function(e) {
        jQuery('#new-appointment').submit();
    });
    jQuery('#new-appointment').on('submit', function(e) {
        e.preventDefault();
        loadingStatus();
        let form_data = jQuery(this).serializeArray();
        $.ajax({
            type: data.rest.endpoints.new_appointment.method,
            dataType: 'json',
            url: data.rest.endpoints.new_appointment.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            let customer = jQuery('#new-appointment #appointment-customer').val();
            loadingStatus();
            successModal(data.rest.messages.new_appointment, true);
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
    jQuery('#type-sitting').on('click', function(e) {
        jQuery('#sitting-modal').foundation('open');
    });
    jQuery('#sitting-send').on('submit', function(e){
        e.preventDefault();
        let email = jQuery(this).find('input[name="sitting-email"]');
        let phone = jQuery(this).find('input[name="sitting-phone"]');
        if (!email.val() && !phone.val()) {
            successModal(data.rest.messages.referral_contact);
        } else {
            // jQuery(this).parsley().validate();
            // if (jQuery(this).parsley().isValid()){
                loadingStatus();
                let form_data = jQuery(this).serializeArray();
                $.ajax({
                    type: data.rest.endpoints.sitting_request.method,
                    dataType: 'json',
                    url: data.rest.endpoints.sitting_request.url,
                    data: form_data,
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                    }
                }).done(function(results){
                    loadingStatus();
                    if (results.message == 'success') {
                        successModal(data.rest.messages.sitting_success, true);
                    } else {
                        successModal(data.rest.messages.error)
                    }
                }).fail(function(xhr){
                    loadingStatus();
                    successModal(data.rest.messages.error)
                });
            // }
        }
    });
    // MYBIGODES ANIMALS
    // check if tab change
    jQuery('#mybigodes-animals-tabs').on('change.zf.tabs', function() {
        if (jQuery('#animals2:visible').length) {
            jQuery('#animals2 .schedule-entry').each(function(i, el) {
                let parent_height = jQuery(el).height();
                jQuery(el).find('button').height(parent_height);
            });
        }
    });
    // get animal
    jQuery(document).on('click', '#mybigodes-animals .animal-icon', function(e) {
        let animal = jQuery(this).attr('data-animal');
        jQuery('.animal-photo').removeClass('active');
        jQuery(this).find('.animal-photo').addClass('active');
        jQuery('#animal-file .grid-body .schedule-entry').remove();
        jQuery('#animal-file .grid-body .schedule-border').remove();
        jQuery('#animal-file .grid-body .schedule-entry').remove();
        if (animal != 0) {
            loadingStatus();
            $.ajax({
                type: data.rest.endpoints.get_animal.method,
                dataType: 'json',
                url: data.rest.endpoints.get_animal.url,
                data: {'animal': animal},
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                let history_template = jQuery('#animals-history-template').html();
                let exams_template = jQuery('#animals-exams-template').html();
                let wellbeing_template = jQuery('#animals-wellbeing-template').html();
                jQuery('.animal-grid').slideUp();
                jQuery('.picture-wrap').show();
                jQuery('#animal-file .picture-box').css('background-image', 'url(' + results.animal.photo + ')');
                jQuery('#picture-animal').val(results.animal.id);
                jQuery('#animal-file input[name="animal-id"]').val(results.animal.id);
                jQuery('#animal-file input[name="animal-name"]').val(results.animal.name);
                jQuery('#animal-file select[name="animal-type"] option[value="' + results.animal.type + '"]').prop('selected', true);
                jQuery('#animal-file select[name="animal-sex"] option[value="' + results.animal.sex + '"]').prop('selected', true);
                jQuery('#animal-file input[name="animal-race"]').val(results.animal.race);
                jQuery('#animal-file input[name="animal-date"]').val(results.animal.date);
                jQuery('#animal-file input[name="animal-weight"]').val(results.animal.weight);
                jQuery('#animal-delete').attr('data-animal', results.animal.id);
                $.each(results.history, function(index, obj) {
                    let item = jQuery(history_template).clone();
                    jQuery('#animals-appointment-detail .appointment-detail-content').empty();
                    jQuery(item).find('.status').addClass(obj.status_class);
                    jQuery(item).find('.type').html(obj.type);
                    jQuery(item).find('.date').html(obj.date.replace(/-/g, '/'));
                    jQuery(item).find('.time').html(obj.time);
                    jQuery(item).find('.motive').html(obj.motive);
                    jQuery(item).find('.vet').html(obj.vet);
                    jQuery(item).find('.status_class').addClass(obj.status_class);
                    jQuery(item).find('.status_class').html(obj.status);
                    jQuery(item).find('.appointment-detail-open').attr('data-animal', obj.animal);
                    jQuery(item).find('.appointment-detail-open').attr('data-type', obj.type);
                    jQuery(item).find('.appointment-detail-open').attr('data-motive', obj.motive);
                    jQuery(item).find('.appointment-detail-open').attr('data-vet', obj.vet);
                    jQuery(item).find('.appointment-detail-open').attr('data-date', obj.date.replace(/-/g, '/'));
                    jQuery(item).find('.appointment-detail-open').attr('data-notes', obj.anamnese);
                    jQuery(item).find('.appointment-detail-open').attr('data-therapy', obj.therapy);
                    jQuery('#animals2 .grid-body').append(item);
                });
                $.each(results.exams, function(index, obj) {
                    let item = jQuery(exams_template).clone();
                    jQuery(item).find('.description').html(obj.description);
                    jQuery(item).find('.date').html(obj.date.replace(/-/g, '/'));
                    jQuery(item).find('.download').text(data.rest.messages.download);
                    jQuery(item).find('.download').attr('href', obj.file);
                    jQuery('#animals3 .grid-body').append(item);
                });
                $.each(results.wellbeing, function(index, obj) {
                    let item = jQuery(wellbeing_template).clone();
                    jQuery(item).find('.type_label').html(obj.type_label);
                    jQuery(item).find('.motive_label').html(obj.motive_label);
                    jQuery(item).find('.date').text(obj.date.replace(/-/g, '/'));
                    jQuery(item).find('.actions .appointment-edit').attr('data-appointment', obj.id);
                    jQuery(item).find('.wellbeing-delete').attr('data-appointment', obj.appointment);
                    jQuery('#animals4 .grid-body').append(item);
                    jQuery('#animals4 .schedule-entry:last').attr('data-animal', obj.animal);
                    jQuery('#animals4 .schedule-entry:last').attr('data-animal-name', obj.animal_name);
                    jQuery('#animals4 .schedule-entry:last').attr('data-appointment', obj.appointment);
                    jQuery('#animals4 .schedule-entry:last').attr('data-type', obj.type);
                    jQuery('#animals4 .schedule-entry:last').attr('data-type-label', obj.type_label);
                    jQuery('#animals4 .schedule-entry:last').attr('data-motive', obj.motive);
                    jQuery('#animals4 .schedule-entry:last').attr('data-motive-label', obj.motive_label);
                    jQuery('#animals4 .schedule-entry:last').attr('data-context', obj.context);
                    jQuery('#animals4 .schedule-entry:last').attr('data-date', obj.date.replace(/-/g, '/'));
                    jQuery('#animals4 .schedule-entry:last').attr('data-day', obj.day);
                    jQuery('#animals4 .schedule-entry:last').attr('data-month', obj.month);
                    jQuery('#animals4 .schedule-entry:last').attr('data-year', obj.year);
                });
                loadingStatus();
                jQuery('#animal-file').slideDown();
                slideTo('#animal-file');
            }).fail(function(xhr){
                loadingStatus();
                console.log(xhr);
            });
        } else {
            jQuery('.picture-wrap').hide();
            jQuery('#animal-file .picture-box').css('background-image', 'url(/wp-content/themes/drbigodes/assets/images/icon-animal.svg)');
            jQuery('#animal-file input[name="animal-id"]').val(0);
            jQuery('#animal-file input[type="text"]').val('');
            jQuery('#animal-file select option:selected').removeAttr('selected');
            jQuery('#animal-file').slideDown();
            slideTo('#animal-file');
        }
    });
    // appointment history details
    jQuery(document).on('click', '.appointment-detail-open', function(){
        let data = jQuery(this);
        let animal = data.attr('data-animal');
        let type = data.attr('data-type');
        let motive = data.attr('data-motive');
        let vet = data.attr('data-vet');
        let date = data.attr('data-date');
        let notes = data.attr('data-notes');
        let therapy = data.attr('data-therapy');
        jQuery('#animals-appointment-detail .appointment-animal').text(animal);
        jQuery('#animals-appointment-detail .appointment-type').text(type);
        jQuery('#animals-appointment-detail .appointment-motive').text(motive);
        jQuery('#animals-appointment-detail .appointment-vet').text(vet);
        jQuery('#animals-appointment-detail .appointment-date').text(date);
        jQuery('#animals-appointment-detail .appointment-notes').text(notes);
        jQuery('#animals-appointment-detail .appointment-therapy').text(therapy);
        jQuery('#animals-appointment-detail').foundation('open');
    });
    // update animal
    jQuery('#animal-data-edit').on('submit', function(e) {
        e.preventDefault();
        loadingStatus();
        // jQuery(this).parsley().validate();
        // if (jQuery(this).parsley().isValid()){
            let form_data = jQuery(this).serializeArray();
            $.ajax({
                type: data.rest.endpoints.animal_update.method,
                dataType: 'json',
                url: data.rest.endpoints.animal_update.url,
                data: form_data,
                beforeSend: function(xhr){
                    xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
                }
            }).done(function(results){
                if (results.message == 'success') {
                    if (results.status == 'edit') {
                        successModal(data.rest.messages.animal_edit_success, true);
                    } else if (results.status == 'new') {
                        successModal(data.rest.messages.animal_create_success, true);
                    }
                } else {
                    successModal(data.rest.messages.error);
                }
                loadingStatus();
                slideTo('#mybigodes');
            }).fail(function(xhr){
                successModal(data.rest.messages.error);
            });
        // }
    });
    // upload photo
    jQuery('#picture-input').on("change", function() {
        let file = this.files[0];
        if (file.size > 1000000) {
            jQuery(this).val('');
            successModal(data.rest.messages.file_size);
        } else {
            jQuery("#picture-form").submit();
        }
    });
    jQuery('#picture-form').on('submit', function(e) {
        e.preventDefault();
        loadingStatus();
        let form_data = new FormData();
        let animal = jQuery('#picture-animal').val();
        form_data.append('picture-animal', animal);
        form_data.append('picture-input', jQuery('#picture-input')[0].files[0]);
        $.ajax({
            type: data.rest.endpoints.animal_photo.method,
            url: data.rest.endpoints.animal_photo.url,
            contentType: false,
            processData:false,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            if (results.message == 'success') {
                jQuery('.picture-box').css('background-image', 'url(' + results.photo + ')');
                jQuery('.animal-profile .animal-icon[data-animal="' + animal + '"] .animal-photo').css('background-image', 'url(' + results.photo + ')');
                successModal(data.rest.messages.photo_success);
            } else {
                successModal(data.rest.messages.error);
            }
        }).fail(function(xhr){
            loadingStatus();
            successModal(data.rest.messages.error);
        });
    });
    //delete animal
    jQuery('#animal-delete').on('click', function(e) {
        e.preventDefault();
        let animal = jQuery(this).attr('data-animal');
        let photo = jQuery('.picture-box').css('background-image');
        let name = jQuery('input[name="animal-name"]').val();
        jQuery('#animal-delete-modal .animal-photo').css('background-image', photo);
        jQuery('#animal-delete-modal .animal-name').html(name);
        jQuery('#animal-delete-modal #animal-delete-confirm').attr('data-animal', animal);
        jQuery('#animal-delete-modal').foundation('open');
    });
    jQuery('#animal-mantain').on('click', function(e) {
        jQuery('#animal-delete-modal').foundation('close');
    });
    jQuery('#animal-delete-confirm').on('click', function(e) {
        let animal = jQuery(this).attr('data-animal');
        let form_data = {
            animal: animal
        };
        loadingStatus();
        $.ajax({
            type: data.rest.endpoints.delete_animal.method,
            dataType: 'json',
            url: data.rest.endpoints.delete_animal.url,
            data: form_data,
            beforeSend: function(xhr){
                xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
            }
        }).done(function(results){
            loadingStatus();
            successModal(data.rest.messages.animal_delete);
        }).fail(function(xhr){
            console.log(xhr);
        });
    });
});
// FUNCTIONS
// GLOBAL
// Form messages
function formMessage(form, status, message) {
    let message_box = form.find('.form-message');
    message_box.addClass(status);
    message_box.empty();
    message_box.html(message);
    message_box.show();
}
// Context messages
function contextMessage(title, text) {
    jQuery('.mybigodes-tips h4').html(title);
    jQuery('.mybigodes-tips p').html(text);
}
jQuery('.tabs-title a').on('click', function() {
    contextMessage('', '');
});
jQuery('#schedule2-label').on('click', function() {
    contextMessage(data.messages.wellbeing_title, data.messages.wellbeling_text);
});
// Success modal messages
function successModal(content, reload) {
    jQuery('#success-modal').foundation('open');
    jQuery('#success-modal .success-message p').html(content);
    if (reload === true) {
        jQuery('#success-modal').on('closed.zf.reveal', function(e) {
            window.location.href = '//' + window.location.host + '/mybigodes?appointment=yes';
        });
    }
}
// Loading status
function loadingStatus() {
    jQuery('#loading-overlay').css('height', '100%');
    jQuery('#loading-overlay').toggleClass('active');
    if (jQuery('#loading-overlay').hasClass('active')) {
        vivus = new Vivus('icon-loading', { duration: 2000 }, null);
    } else {
        vivus.destroy();
    }
}
// REGISTER
//reset form
function resetRegisterForm() {
    jQuery('#register-modal #register-first').show();
    jQuery('#register-modal #register-last').hide();
    jQuery('.form-navigation .next').show();
    jQuery('.form-navigation [type=submit]').hide();
}
//main control
function registerModalControls() {
    var $sections = jQuery('.form-section');
    function navigateTo(index) {
        jQuery('#register-first').hide();
        jQuery('#register-last').slideDown();
        jQuery('.form-navigation .next').hide();
        jQuery('.form-navigation [type=submit]').show();
    }
    jQuery('.form-navigation .next').on('click', function() {
        console.log('lc')
        jQuery('.customer-register').parsley().whenValidate({
            group: 'block-0'
        }).done(function() {
            navigateTo(1);
        });
    });
    $sections.each(function(index, section) {
        jQuery(section).find(':input').attr('data-parsley-group', 'block-' + index);
    });
    $sections.eq(0).addClass('current');
}

// REGISTER - district change
jQuery('.register-district').on('change', function(e){
    let district = jQuery(e.target).val();
    let counties = JSON.parse(jQuery('.register-county').attr('data-counties'));

    jQuery('.register-county').empty();

    for (let key in counties) {
        let value = counties[key];
        if (key.includes(district)) {
            let county_entry = '<option value="' + key + '">' + value + '</option>';
            jQuery('.register-county').append(county_entry);
        }
    }

    if (jQuery('.register-county option').length) {
        jQuery('.register-county-container').fadeIn();
    } else {
        jQuery('.register-county-container').fadeOut();
    }
    jQuery('.register-county').trigger('change');
});

// MYBIGODES
// POINTS
// Reload points history
function reloadHistory(customer) {
    jQuery('.points-screen').hide();
    jQuery('#points-history').show();
    jQuery('#points-history .points-entry').remove();
    let template = jQuery('#points-history-template').html();
    jQuery.ajax({
        type: data.rest.endpoints.points_history.method,
        dataType: 'json',
        url: data.rest.endpoints.points_history.url,
        data: 'customer=' + customer,
        beforeSend: function(xhr){
            xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
        }
    }).done(function(results){
        jQuery.each(results, function(index, obj) {
            let item = jQuery(template).clone();
            jQuery(item).find('.event').html(obj.event);
            jQuery(item).find('.date').html(obj.date.replace(/-/g, '/'));
            jQuery(item).find('.points').html(obj.points);
            if (obj.points.includes('-')) {
                jQuery(item).find('.points').addClass('secondary');
            }
            jQuery('.points-history').append(item);
        });
    }).fail(function(xhr){
        console.log(xhr);
    });
}
// APPOINTMENTS
function startCalendar() {
    let days = jQuery(this).attr('data-week');
    let settings = {
        Color: '#662D91',
        LinkColor: '#333',
        NavShow: true,
        NavVertical: false,
        DateTimeShow: true,
        DateTimeFormat: 'mmm, yyyy',
        DatetimeLocation: '',
        EventClick: 'getSlots',
        EventTargetWholeDay: false,
        DisabledDays: days,
        ModelChange: data
    }
    var calendar = caleandar(document.getElementById('appointment-calendar-date'));
    updateCalendar();
}
function getCalendarData(date, vet) {
    let form_data = {
        date: date,
        vet: vet,
        type: jQuery('#appointment-type').val()
    };
    loadingStatus();
    jQuery.ajax({
        type: data.rest.endpoints.calendar.method,
        dataType: 'json',
        url: data.rest.endpoints.calendar.url,
        data: form_data,
        beforeSend: function(xhr){
            xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
        }
    }).done(function(results){
        loadingStatus();
        jQuery.each(results, function(i, el) {
            let day = jQuery('.cld-day[data-monthday="' + i + '"]');
            jQuery(day).addClass('active');
            jQuery(day).attr('data-schedule', JSON.stringify(el));
        });
    }).fail(function(xhr){
        loadingStatus();
    });
}
function updateCalendar() {
    let vet = jQuery('#mybigodes-new-appointment').attr('data-vet');
    let fulldate = jQuery('#appointment-calendar-date .cld-datetime .today').html().split(' ');
    let month = jQuery.inArray(fulldate[0], months) + 1;
    if (month < 10) {
        month = '0' + month;
    }
    let year = fulldate[1];
    let date = month + year;
    jQuery('#appointment-vet').val(vet);
    jQuery('#appointment-calendar-info').attr('data-date', month + '-' + year);
    jQuery('#mybigodes-new-appointment').attr('data-my', date);
    jQuery('.cld-day').removeClass('active');
    jQuery('.cld-day').attr('data-schedule', '');
    getCalendarData(date, vet);
}
function updateVet() {
    jQuery('#new-appointment-confirm-modal .appointment-data .vet').empty();
    jQuery('#new-appointment-confirm-modal .appointment-data .animal-icon').each(function(i, el) {
        jQuery('#na-step-5 .photo-button-image.active').parent().clone().appendTo('#new-appointment-confirm-modal .appointment-data .vet');
    });
}
function appointmentCleanup() {
    jQuery('#mybigodes-new-appointment .cld-number').removeClass('selected');
    jQuery('#mybigodes-new-appointment .calendar-date').empty();
    jQuery('#mybigodes-new-appointment #appointment-calendar-hours li').remove();
    jQuery('#mybigodes-new-appointment .cld-main').remove();
    jQuery('#new-appointment-confirm-modal .animal').empty();
    jQuery('#new-appointment-confirm-modal .service').empty();
    jQuery('#new-appointment-confirm-modal .vet').empty();
    jQuery('#new-appointment-confirm-modal .animal').empty();
    jQuery('#new-appointment-confirm-modal .service').empty();
    jQuery('#new-appointment-confirm-modal .vet').empty();
}
function appointmentReset() {
    appointmentCleanup();
    jQuery('.mybigodes-form-step .photo-button-image').removeClass('active');
    jQuery('.mybigodes-form-step .icon-button-image').removeClass('active');
    jQuery('.mybigodes-form-step .list').removeClass('active');
    jQuery('.mybigodes-form-step .animal-photo').removeClass('active');
    jQuery('.mybigodes-form-step .icon-button').removeClass('active');
    jQuery('.mybigodes-form-step .next-step').hide();
    jQuery('.mybigodes-form-step').hide();
    jQuery('#na-step-1').show();
    jQuery('#na-step-1 .next-step').show();
}
function reloadAppointments() {
    let customer = jQuery('.mybigodes').attr('data-customer');
    let template = jQuery('#schedule-appointments-template').html();
    let form_data = {
        customer: customer
    };
    jQuery.ajax({
        type: data.rest.endpoints.get_appointments.method,
        dataType: 'json',
        url: data.rest.endpoints.get_appointments.url,
        data: form_data,
        beforeSend: function(xhr){
            xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
        }
    }).done(function(results){
        jQuery('#schedule1 .grid-body > .schedule-entry').remove();
        jQuery('#schedule1 .grid-body > .schedule-border').remove();
        jQuery('#schedule1 .schedule-empty').remove();
        jQuery.each(results, function(index, obj) {
            let item = jQuery(template).clone();
            jQuery(item).first().attr('data-vet', obj.vet_id);
            jQuery(item).first().attr('data-type', obj.type);
            jQuery(item).first().attr('data-month', obj.month);
            jQuery(item).first().attr('data-photo', obj.vet_photo);
            jQuery(item).first().attr('data-name', obj.animal);
            jQuery(item).first().attr('data-service', obj.type_name);
            jQuery(item).first().attr('data-service-icon', obj.type_icon);
            jQuery(item).first().attr('data-vet-photo', obj.vet_photo);
            jQuery(item).first().attr('data-vet-name', obj.vet);
            jQuery(item).first().attr('data-appointment', obj.id);
            jQuery(item).first().addClass(obj.status_class);
            jQuery(item).find('div.status').addClass(obj.type);
            jQuery(item).find('.animal').text(obj.animal);
            jQuery(item).find('.date').text(obj.date);
            jQuery(item).find('.hour').text(obj.hour);
            jQuery(item).find('.type').text(obj.type_name);
            jQuery(item).find('.motive').text(obj.motive);
            jQuery(item).find('.vet').text(obj.vet);
            jQuery(item).find('.button-holder.status').text(obj.status);
            jQuery(item).find('.button-holder button').attr('data-appointment', obj.id);
            jQuery(item).find('.cell:last-child').addClass(obj.status_class);
            jQuery(item).find('span.status').text(obj.status);
            jQuery('#schedule1 .grid-body').append(item);
        });
        jQuery('#schedule1-label').trigger('click');
    }).fail(function(xhr){
        loadingStatus();
    });
}
function reloadWellbeingAppointments() {
    let customer = jQuery('.mybigodes').attr('data-customer');
    let template = jQuery('#schedule-wellbeing-template').html();
    let form_data = {
        customer: customer
    };
    jQuery.ajax({
        type: data.rest.endpoints.get_wellbeing_appointments.method,
        dataType: 'json',
        url: data.rest.endpoints.get_wellbeing_appointments.url,
        data: form_data,
        beforeSend: function(xhr){
            xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
        }
    }).done(function(results){
        jQuery('#schedule2 .grid-body > .schedule-entry').remove();
        jQuery('#schedule2 .grid-body > .schedule-border').remove();
        jQuery('#schedule2 .schedule-empty').remove();
        jQuery.each(results, function(index, obj) {
            let item = jQuery(template).clone();
            jQuery(item).first().attr('data-animal', obj.animal_id);
            jQuery(item).first().attr('data-animal-name', obj.animal_name);
            jQuery(item).first().attr('data-appointment', obj.appointment);
            jQuery(item).first().attr('data-type', obj.type);
            jQuery(item).first().attr('data-motive', obj.motive);
            jQuery(item).first().attr('data-motive-label', obj.motive_label);
            jQuery(item).first().attr('data-day', obj.day);
            jQuery(item).first().attr('data-month', obj.month);
            jQuery(item).first().attr('data-year', obj.year);
            jQuery(item).first().addClass(obj.status);
            jQuery(item).find('div.status').addClass(obj.type);
            jQuery(item).find('.animal').text(obj.animal_name);
            jQuery(item).find('.date').text(obj.date);
            jQuery(item).find('.type').text(obj.type_label);
            jQuery(item).find('.motive').text(obj.motive_label);
            jQuery(item).find('.vet').text(obj.vet);
            jQuery(item).find('.button-holder button').attr('data-appointment', obj.appointment);
            jQuery('#schedule2 .grid-body').append(item);
        });
    }).fail(function(xhr){
        loadingStatus();
    });
}
function updateAppointmentAddress() {
    let district = jQuery('#customer-district').val();
    let county = jQuery('#customer-county').val();
    jQuery('#appointment-address').val(jQuery('#customer-address').val());
    jQuery('#appointment-zip').val(jQuery('#customer-zip').val());
    jQuery('#appointment-district').val(district);
    jQuery('#appointment-county').val(county);
    jQuery('#appointment-locality').val(jQuery('#customer-locality').val());
    jQuery('#appointment-phone').val(jQuery('#customer-phone').val());
}
// ANIMALS
// reload animal list
function reloadAnimals(customer) {
    jQuery.ajax({
        type: data.rest.endpoints.get_animals.method,
        dataType: 'json',
        url: data.rest.endpoints.get_animals.url,
        data: 'customer=' + customer,
        beforeSend: function(xhr){
            xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
        }
    }).done(function(results){
        let template = jQuery('#animals-profile-template').html();
        jQuery('.animal-profile .animal-icon:not(.animal-new').remove();
        jQuery.each(results, function(index, obj) {
            let item = jQuery(template).clone();
            if (obj.data.animal.photo === 'undefined') {
             var photo = '/wp-content/themes/drbigodes/assets/images/icon-animal.svg';
            } else {
                var photo = obj.data.animal.photo;
            }
            jQuery(item).attr('data-animal', obj.data.animal.id);
            jQuery(item).find('.animal-photo').css('background-image', 'url(' + photo + ')');
            jQuery(item).find('.animal-name').html(obj.data.animal.name);
            jQuery('.animal-profile').append(item);
        });
    }).fail(function(xhr){
        console.log(xhr);
    });
}
// SUPPORT
// Substring search polyfill
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
    if (search instanceof RegExp) {
        throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
        return this.indexOf(search, start) !== -1;
    };
}
// Smooth scrolling
function slideTo(element) {
    jQuery('html, body').animate({
        scrollTop: jQuery(element).offset().top
    }, 500);
}
// Clean appointment package title when leaving screen
jQuery('.tabs-title a').on('click', function(e) {
    jQuery('.package-title').hide();
});
// Check for query string params
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
// Modal window
function toggleModal(modal) {
    modal.style.display = 'block';
}